import { render, staticRenderFns } from "./ChangeAddress.vue?vue&type=template&id=77f30e7d&scoped=true&"
import script from "./ChangeAddress.vue?vue&type=script&lang=js&"
export * from "./ChangeAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f30e7d",
  null
  
)

export default component.exports